import { ElementRef, Injectable, NgZone } from '@angular/core';
import { fromEvent, merge, Subject, timer } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class LayoutService {
  private componentsObs: { [tag: string]: ElementRef } = {};

  /** Forzará la actualización de las variables. *forceResizeSub.next()* */
  public forceResizeSub = new Subject<void>();

  constructor(private zone: NgZone) {
    this.subResize();
  }

  /**
   * Al agrega un elemento se agregará una variable en css *--{tagName}-height* y *--{tagName}-width*
   * @param el Debe estar inicializado, recomendable usar *ngAfterViewInit* o *setTimeout*.
   * @param customKey Si se requiere una key personalizada. *--{customKey}-height* y *--{customKey}-width*
   *
   * *Si se desea forzar el actualizado de las variables se puede usar {@link forceResizeSub}
   */
  addComponentHeight(el: ElementRef, customKey?: string) {
    if (!el?.nativeElement) throw new Error('El elemento que se está pasando no está inicializado, compruebe donde se usa addComponentHeight');
    const key = customKey || (el.nativeElement.tagName as string).toLowerCase();
    this.componentsObs[key] = el;
    this.forceResizeSub.next();
  }

  private subResize() {
    this.zone.runOutsideAngular(() => {
      merge(fromEvent(window, 'resize'), timer(0), this.forceResizeSub)
        .pipe(debounceTime(300))
        .subscribe(() => {
          this.zone.run(() => this.onResize());
        });
    });
  }

  private onResize() {
    const comp = this.componentsObs;
    Object.keys(comp).forEach(k => {
      let height = comp[k].nativeElement.getBoundingClientRect().height;

      const { marginTop, marginBottom } = window.getComputedStyle(comp[k].nativeElement);
      const top = Number(marginTop.replace('px', ''));
      const bottom = Number(marginBottom.replace('px', ''));
      if (top) height += top;
      if (bottom) height += bottom;

      const width = comp[k].nativeElement.offsetWidth;
      document.documentElement.style.setProperty(`--${k}-height`, `${height}px`);
      document.documentElement.style.setProperty(`--${k}-width`, `${width}px`);
    });
  }
}
